import React from "react";
import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";
import { postFetchAxios } from "../../Services/commonService";
import { API_BADLA_ORDER_AVERAGE } from "../../utils/api/ApiConstant";

const AverageBadla = ({ rowData }) => {
  const userId = useSelector((state) => state.user?.user?.userId);

  // fech dollar rate
  const { data: badlaOrderAverageData } = useQuery({
    queryKey: ["badlaOrderAverageData", userId],
    queryFn: async () =>
      await postFetchAxios({
        url: API_BADLA_ORDER_AVERAGE,
        payload: {
          userId,
          scriptId: rowData?._id,
        },
      }),
    enabled: !!userId,
  });

  return (
    <div className="recentOrders desktop_ui ">
      <table className="report-card-box">
        <thead>
          <tr>
            <th className="text-center text-start">Instrument</th>
            <th className="text-center text-end">Buy Average</th>
            <th className="text-center text-end">Sell Average</th>
            <th className="text-center text-end">Total Average</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>COMEX</td>
            <td>{badlaOrderAverageData?.buyAvg?.[0]?.avgComex}</td>
            <td>{badlaOrderAverageData?.sellAvg?.[0]?.avgComex}</td>
            <td>{badlaOrderAverageData?.totalAvg?.[0]?.avgComex}</td>
          </tr>
          <tr>
            <td>MCX</td>
            <td>{badlaOrderAverageData?.buyAvg?.[0]?.avgMcx}</td>
            <td>{badlaOrderAverageData?.sellAvg?.[0]?.avgMcx}</td>
            <td>{badlaOrderAverageData?.totalAvg?.[0]?.avgMcx}</td>
          </tr>
          <tr>
            <td>DGCX</td>
            <td>{badlaOrderAverageData?.buyAvg?.[0]?.avgDgcx}</td>
            <td>{badlaOrderAverageData?.sellAvg?.[0]?.avgDgcx}</td>
            <td>{badlaOrderAverageData?.totalAvg?.[0]?.avgDgcx}</td>
          </tr>
          <tr>
            <td>BADLA AVG</td>
            <td>{badlaOrderAverageData?.buyAvg?.[0]?.avgBadla}</td>
            <td>{badlaOrderAverageData?.sellAvg?.[0]?.avgBadla}</td>
            <td>{badlaOrderAverageData?.totalAvg?.[0]?.avgBadla}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default AverageBadla;
